import { TYPO } from "styles/Typo";
import { useEffect, useState } from "react";
import CorpInfoModal from "./CorInfoModal";
import useIsDetailLoading from "states/detailLoading";
import { useAutoToggleOpen } from "./useAutoToggleOpen";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";
import { useParams } from "next/navigation";
import EmptyData from "../EmptyData";
import moment from "moment-timezone";
import { trackPageAction } from "lib/analytics/core/actions";

function CorpInfoItem({
  item,
  data,
  index,
  firstOpen,
}: {
  item: { title: string; key: string };
  index: number;
  data: any;
  firstOpen: boolean;
}) {
  const [isOpen, setIsOpen] = useState(firstOpen);
  useEffect(() => {
    setIsOpen(firstOpen);
  }, [firstOpen]);
  return (
    <div
      className="overflow-hidden cursor-pointer "
      onClick={() => {
        trackPageAction(isOpen ? "collapse_stock_info" : "expand_stock_info");
        setIsOpen(!isOpen);
      }}
      data-gtm-id={`sDetail-corp-info-item-${item?.key}`}
    >
      <div
        className={`px-4 py-[10px] flex justify-between items-center bg-gray2 cursor-pointer ${
          index === 0 ? "" : "border-t border-gray15"
        }`}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <p
          className={`${TYPO.TYPO6_MD} text-gray80 whitespace-nowrap !leading-[26px]`}
        >
          {item?.title}
        </p>
        <div
          style={{
            transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
            transition: "transform 0.6s ease",
          }}
        >
          <ArrowIcon />
        </div>
      </div>
      <div
        className="flex items-center  overflow-hidden bg-white"
        style={{
          maxHeight: isOpen ? "150px" : "0px",
          borderTop: isOpen ? `1px solid ${TAILWIND_TO_CSS["gray15"]}` : "none",

          transition: "max-height 0.6s ease",
        }}
      >
        <div className="p-4 flex flex-col gap-2">
          <p
            className={`${TYPO.TYPO7_1_RG} text-gray70`}
            style={{
              wordWrap: "break-word",
              wordBreak: "keep-all",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            {data[item?.key]}
          </p>
        </div>
      </div>
    </div>
  );
}

function CorpInfoItemWrapper({ itemProfileData }: { itemProfileData: any }) {
  const firstOpen = useAutoToggleOpen({ wrapId: "corp-info-item-wrapper" });
  const KEYS = [
    {
      title: "주요 정보",
      key: "business_summary",
    },
    {
      title: "핵심 사업",
      key: "core_items",
    },
  ];
  if (itemProfileData?.latest_updates)
    KEYS.push({
      title: "최근 사업",
      key: "latest_updates",
    });

  return (
    <div
      className="flex flex-col overflow-hidden rounded-[10px] border border-gray15"
      id="corp-info-item-wrapper"
    >
      {KEYS.map((item, index) => (
        <CorpInfoItem
          key={index}
          item={item}
          index={index}
          data={itemProfileData}
          firstOpen={index === 0 ? firstOpen : false}
        />
      ))}
    </div>
  );
}

function CorpInfo({ itemProfileData }: { itemProfileData: any }) {
  const isLoading = useIsDetailLoading();
  const { ticker } = useParams();
  const lastUpdate = moment(itemProfileData?.issue_at).format("M월 D일");
  if (isLoading) return null;
  if (!itemProfileData || !itemProfileData?.business_summary)
    return (
      <div className="px-6 pt-[30px] pb-1 flex flex-col gap-4">
        <h3 className={`${TYPO.TYPO6_SB} text-gray90`}>기업 정보</h3>
        <EmptyData title="아직 정보가 없어요" />
      </div>
    );

  const KEYS = [
    {
      title: "주요 정보",
      key: "business_summary",
    },
    {
      title: "핵심 사업",
      key: "core_items",
    },
  ];
  if (itemProfileData?.latest_updates)
    KEYS.push({
      title: "최근 사업",
      key: "latest_updates",
    });
  return (
    <div className="px-6 pt-[30px] pb-1 flex flex-col gap-4">
      <h3 className={`${TYPO.TYPO6_SB} text-gray90`}>사업</h3>
      <div className="flex flex-col gap-1">
        <CorpInfoItemWrapper itemProfileData={itemProfileData} />
        <div className="flex items-center justify-end ">
          <p className={`${TYPO.TYPO8_RG} text-gray40`}>
            {`마지막 업데이트 ・ ${lastUpdate} `}
          </p>
        </div>
      </div>
      {/* <div className="flex flex-col overflow-hidden rounded-[10px] border border-gray15">
        {KEYS.map((item, index) => (
          <CorpInfoItem
            key={index}
            item={item}
            index={index}
            data={itemProfileData}
          />
        ))}
      </div> */}
      {/* <div className="bg-gray2 rounded-[16px] w-full">
        <div className="px-5 py-3 flex flex-col gap-1">
          <p
            className={`${TYPO.TYPO6_RG} text-gray70`}
            data-testid="value-scouter-business-summary"
            style={{
              wordWrap: "break-word",
              wordBreak: "keep-all",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            {itemProfileData?.business_summary}
          </p>
        </div>
        <div
          className="border-t border-gray15 px-5 py-3 flex justify-between cursor-pointer"
          onClick={() => {
            setIsOpen(true);
          }}
          data-testid="value-scouter-business-summary-more-button"
        >
          <p className={`${TYPO.TYPO7_MD} text-gray80`}>핵심 사업 보기</p>
          <Forward fill="gray40" height={16} width={16} />
        </div>
      </div> */}
      {/* {isOpen && (
        <CorpInfoModal
          setModalOpen={setIsOpen}
          isModalOpen={isOpen}
          data={{
            core_items: itemProfileData?.core_items,
            latest_updates: itemProfileData?.latest_updates,
          }}
        />
      )} */}
    </div>
  );
}
const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6.02167 4.3625L2.34667 8.0375C2.22167 8.1625 2.07584 8.22292 1.90917 8.21875C1.74251 8.21458 1.59667 8.15 1.47167 8.025C1.34667 7.9 1.28417 7.75417 1.28417 7.5875C1.28417 7.42083 1.34667 7.275 1.47167 7.15L5.30917 3.3C5.40917 3.2 5.52167 3.125 5.64667 3.075C5.77167 3.025 5.89667 3 6.02167 3C6.14667 3 6.27167 3.025 6.39667 3.075C6.52167 3.125 6.63417 3.2 6.73417 3.3L10.5842 7.15C10.7092 7.275 10.7696 7.42292 10.7654 7.59375C10.7613 7.76458 10.6967 7.9125 10.5717 8.0375C10.4467 8.1625 10.3008 8.225 10.1342 8.225C9.96751 8.225 9.82167 8.1625 9.69667 8.0375L6.02167 4.3625Z"
        fill="var(--gray40)"
      />
    </svg>
  );
};
export default CorpInfo;
